module.exports = __webpack_public_path__ + "img/cancel_takeoff_disabled.97e51b42.svg";